import styled from '@emotion/styled';
import React from 'react';
import { theme } from 'styles/theme/theme';

export interface UDRangeProps {
  min: number;
  max: number;
  step?: number;
  value: number;
  /** Значение уже числом — `event.target.value` у ползунка строка. */
  onChange: (value: number) => void;
  /** Имя для скринридера: у ползунка нет своей подписи. */
  'aria-label': string;
  disabled?: boolean;
  /** Подпись значения справа от ползунка («40%»). Без неё — только ползунок. */
  formatValue?: (value: number) => React.ReactNode;
  /** Класс строки. Ползунок растягивается на всю её ширину. */
  className?: string;
}

/**
 * Нативный ползунок `<input type="range">` в цвете акцента темы, с необязательной подписью значения.
 * Клавиатура (стрелки, Home/End, PageUp/PageDown) и роль `slider` остаются браузерными.
 */
function UDRange(props: UDRangeProps) {
  const { min, max, step = 1, value, onChange, disabled, formatValue, className } = props;

  return (
    <Row className={className}>
      <Input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        aria-label={props['aria-label']}
        onChange={(event) => onChange(Number(event.target.value))}
      />
      {formatValue && <Value>{formatValue(value)}</Value>}
    </Row>
  );
}

export default UDRange;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

// Специфичность одного класса: экран со своим акцентом (редактор медиа-менеджера) перекрашивает ползунок своим правилом.
const Input = styled.input`
  flex: 1;
  min-width: 0;
  margin: 0;
  accent-color: ${theme.colors.AccentNaplesYellow};
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;

const Value = styled.span`
  flex: 0 0 auto;
  min-width: 3ch;
  text-align: right;
  font-variant-numeric: tabular-nums;
`;
